
import axiosInstance, { axiosPublicInstance } from "../config/AuthInterceptors";
import { ICompleteChangePasswordBody, IGenericAuthResponse, ILoginBody, ILoginResponse, IRegisterBody, IStartChangePasswordBody } from "../interfaces/auth";

const authService = {
    login: (body: ILoginBody) => axiosInstance.post<ILoginResponse>("users/login", body).then(res => res.data),
    startChangePassword: (body: IStartChangePasswordBody) => axiosPublicInstance.post<IGenericAuthResponse>("users/start-restore-password", body).then(res => res.data),
    completeChangePassword: (body: ICompleteChangePasswordBody) => axiosPublicInstance.post<IGenericAuthResponse>("users/complete-restore-password", body).then(res => res.data),
    register: (body: IRegisterBody) => axiosPublicInstance.post<IGenericAuthResponse>("users/register", body).then(res => res.data),
}

export default authService;